import { CanDeactivateFn } from '@angular/router';

export interface NuevoRegaloFlowExitAware {
  confirmExitFlow(): boolean | Promise<boolean>;
}

export const nuevoRegaloFlowExitGuard: CanDeactivateFn<NuevoRegaloFlowExitAware> = (component) =>
  component.confirmExitFlow();
